import React from "react";
import { Paper, Typography } from "@mui/material";

// comments: English only
export default function KPI({ title, value }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.2,
        border: "1px solid #eadfca",
        borderRadius: 2,
        background: "#fffdf8",
        boxShadow: "0 8px 22px rgba(91, 75, 39, 0.06)",
        textAlign: "center",
        display: "grid",
        gap: 0.5,
        justifyItems: "center",
      }}
    >
      <Typography variant="subtitle2" sx={{ color: "#b79b5b", fontWeight: 800 }}>
        {title}
      </Typography>
      <Typography variant="h5" sx={{ color: "#4f545c", fontWeight: 900, lineHeight: 1.2 }}>
        {value}
      </Typography>
    </Paper>
  );
}
